import React, { Component, Fragment } from "react";
import "react-datepicker/dist/react-datepicker.css";
import CampaignsFilterSelect from "./CampaignsFilterSelect";

import axios from "axios";
import { Spinner } from "./Spinner";

import { Alert } from "reactstrap";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import DatePicker from "react-datepicker";
import PropTypes from "prop-types";
import {
  makeStyles,
  Button,
  TextField,
  Grid,
  Switch,
  withStyles,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Container,
  AppBar,
  Tabs,
  Tab,
  Box,
  Typography,
  DialogActions,
  DialogContent,
  DialogContentText,
  Dialog,
  DialogTitle,
  Divider,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Paper,
} from "@material-ui/core/";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { LoggedUserContext } from "../LoggedUserContext";
import { acquireToken } from "../adalConfig";

const MySwal = withReactContent(Swal);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(0),
    minWidth: 175,
    maxWidth: 175,
  },
  chips: {
    display: "block",
    flexWrap: "wrap",
  },
  chip: {
    margin: 0,
  },
  noLabel: {
    marginTop: theme.spacing(1),
  },
}));

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(0),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#FFE600",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#FFE600",
      border: "6px solid #000",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default class CampaignsCreateForm extends Component {
  state = {
    buttonDisabled: false,
    createCampaignText: "CREATE CAMPAIGN",
    exportResultsText: "EXPORT RESULTS",
    executeQueryText: "EXECUTE QUERY",
    loading: false,
    campaignName: "",
    campaignDescription: "",
    EmailAccount: "",
    emailAddress: "",
    AreaCheck: true,
    Area: [],
    SubAreaCheck: true,
    SubArea: [],
    CountryCheck: true,
    Country: [],
    CityCheck: true,
    City: [],
    LocationCheck: true,
    Location: [],
    ServiceLineCheck: true,
    ServiceLine: [],
    SubManagementUnitCheck: true,
    SubManagementUnit: [],
    SubServiceLineCheck: true,
    SubServiceLine: [],
    RankCheck: true,
    Rank: [],
    HireDateStart: null,
    HireDateEnd: null,
    CampaignsInCheck: true,
    CampaignsIn: [],
    CampaignsInList: [],
    CloudRedboxCheck: true,
    CloudRedbox: [],
    citrixEnrolled: null,
    CitrixDeviceModelCheck: true,
    CitrixDeviceModel: [],
    CitrixDeviceModeCheck: true,
    CitrixDeviceMode: [],
    CitrixOSTypeCheck: true,
    CitrixOSType: [],
    CitrixOSVersionCheck: true,
    CitrixOSVersion: [],
    mwEnabled: null,
    mwEnrolled: null,
    IntuneDeviceModelCheck: true,
    IntuneDeviceModel: [],
    IntuneOSTypeCheck: true,
    IntuneOSType: [],
    IntuneDeviceTypeCheck: true,
    IntuneDeviceType: [],
    IntuneOSVersionCheck: true,
    IntuneOSVersion: [],
    intuneAppsIncludedCheck: true,
    intuneExcludeApps: [],

    citrixEnrolledInclude: null,
    mwEnrolledInclude: null,
    mwEnabledInclude: null,
    citrixEnrolledDateStart: null,
    citrixEnrolledDateEnd: null,
    citrixLastActiviyStart: null,
    citrixLastActiviyEnd: null,
    intuneEnrollmentDateStart: null,
    intuneEnrollmentDateEnd: null,
    intuneLastCheckInDateStart: null,
    intuneLastCheckInDateEnd: null,
    tabValue: 0,

    AreaList: [],
    SubAreaList: [],
    CountryList: [],
    CityList: [],
    //LocationList: [],
    //LocationDescriptionList: [],
    ServiceLineList: [],
    SubManagementUnitList: [],
    SubServiceLineList: [],
    RankList: [],
    CloudRedboxList: [],
    CitrixDeviceModelList: [],
    CitrixDeviceModeList: [],
    CitrixOSTypeList: [],
    CitrixOSVersionList: [],
    CitrixAppsList: [],
    IntuneDeviceModelList: [],
    IntuneOSTypeList: [],
    IntuneDeviceTypeList: [],
    IntuneOSVersionList: [],
    IntuneAppsList: [],
    citrixAppsIncluded: [],
    citrixAppsNotIncluded: [],
    intuneAppsIncluded: [],
    intuneAppsNotIncluded: [],
    peopleMeet: 0,
    peopleExcluded: 0,
    continueForm: true,
    continueActive: true,

    accountList: [],
    account: [],
    userEmailAccounts: [],
    validPeopleList: 0,
    invalidEmailsList: 0,
    doNotDisturbEmailsList: 0,
    openImportExcel: false,
    loadingFile: false,
    importedFromExcel: [],

    validtemplateFile: true,
    CampaignNameError: "",
    CampaignDescriptionError: "",
    EmailAccountError: "",
    TestEmailAddressError: "",
    EmailTemplateError: "",

    ValidUserFile: true,
    ExcelFileError: "",

    templateFilename: "",
    campaignsInIds: {},
    CampaignsInIdList: [],

    EmailsSubject: "",
    EmailsSubjectError: "",

    ExcelFileBase64: "",
    ValidGPNList: [],
  };
  async updateFilters(name, values) {
    switch (name) {
      case "Area":
        this.setState({
          SubAreaList: await this.setFilterList("SubArea", values),
          CountryList: await this.setCountryFilterList("Area", values),
        });
        break;
      case "SubArea":
        this.setState({
          //CountryList: await this.setFilterList("Country", values),
          CountryList: await this.setCountryFilterList("SubArea", values),
        });
        break;
      case "Country":
        this.setState({
          CityList: await this.setFilterList("City", values),
        });
        break;
      /*
      case "City":
        this.setState({
          LocationList: await this.setFilterList("Location", values),
        });
        }, async () => {
          //Then for each location in LocationList, change location description
          Promise.all(
            this.state.LocationList.map(locationItem => {
              this.setFilterList("LocationDescription", locationItem);
              //TODO: what if an item is blank?
            })
          ).then(locationDescriptions => {
            this.setState({
              LocationDescriptionList: locationDescriptions,
            })
          });
          this.setState({
            LocationDescriptionList: await this.setFilterList("LocationDescription", this.state.LocationList),
          });
        });
        break;
      case "Location":
        //For each location in LocationList, change location description
        Promise.all(
          this.state.LocationList.map(locationItem => {
            this.setFilterList("LocationDescription", locationItem);
          })
        ).then(locationDescriptions => {
          this.setState({
            LocationDescriptionList: locationDescriptions,
          })
        });
        if (this.state.LocationList.length > 0) {
          this.setState({
            LocationDescriptionList: await this.setFilterList("LocationDescription", this.state.LocationList),
          });
        }
        break;
        */
      case "ServiceLine":
        this.setState({
          SubManagementUnitList: await this.setFilterList(
            "SubManagementUnit",
            values
          ),
        });
        break;
      case "CitrixOSType":
        this.setState({
          CitrixOSVersionList: await this.setFilterList(
            "CitrixOSVersion",
            values
          ),
        });
        break;
      case "IntuneOSType":
        this.setState({
          IntuneOSVersionList: await this.setFilterList(
            "IntuneOSVersion",
            values
          ),
        });
        break;
      default:
    }
  }

  handleChangeContinue = (name) => ({ target: { value } }) => {
    if (this.state.continueForm) {
      if (!this.ValidateNewCampaignForm()) {
        return;
      }
    }
    this.setState({
      ...this.state,
      [name]: !this.state.continueForm,
    });
  };

  async componentDidMount() {
    acquireToken().then(async (token) => {
      this.setState({ loading: true });

      let itemsAccounts = [];
      let url = `${process.env.REACT_APP_API_URL}/EmailAccountAPI/GetEmailAccountsPerUserId/true`;

      await axios
        .get(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          if (res.data.code === 0) {
            itemsAccounts = res.data.items;
          } else {
            MySwal.fire({
              icon: "error",
              title:
                "An error has occurred while retrieving the email accounts",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title:
                "An error has occurred while retrieving the email accounts",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });

      let id = this.context.userId;

      let associatedAccount = [];
      url = `${
        process.env.REACT_APP_API_URL
      }/EmailAccountAPI/GetEmailAccountsPerUserId/true${
        id !== this.context.userId
          ? "?ui=" + this.encryptStringXORtoHex(id, "CampaignToolEncKey")
          : ""
      }`;
      let itemsEmailAccounts;
      await axios
        .get(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          if (res.data.code === 0) {
            itemsEmailAccounts = res.data.items;
          } else {
            MySwal.fire({
              icon: "error",
              title:
                "An error has occurred while retrieving the email accounts",
              ////text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title:
                "An error has occurred while retrieving the email accounts",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });

      itemsEmailAccounts.map((obj) =>
        associatedAccount.push(obj.emailAccountName)
      );
      let listAccounts = [];
      associatedAccount.map((obj) =>
        itemsEmailAccounts.map((rol) =>
          rol.emailAccountName === obj ? null : null
        )
      );

      url = `${process.env.REACT_APP_API_URL}/CampaingAPI/GetCampaings/true`;

      await axios
        .get(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          if (res.data.code === 0) {
            let campaignNames = [];
            let campaignIds = [];
            res.data.items.forEach((campaign) => {
              campaignIds[
                campaign.campaingName
              ] = campaign.campaingId.toString();
              campaignNames.push(campaign.campaingName);
            });
            this.setState({
              CampaignsInList: campaignNames,
              campaignsInIds: campaignIds,
            });
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the campaigns",
              ////text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the campaigns",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });

      this.setState({
        accountList: itemsAccounts,
        account: associatedAccount,
        userEmailAccounts: listAccounts,
      });

      this.setState({
        CountryList: await this.setCountryFilterList("", [""]),
      });

      this.setState({
        AreaList: await this.setFilterList("Area", [""]),
      });
      /*
      this.setState({
        LocationList: await this.setFilterList("Location", [""]),
      });
      this.setState({
        LocationList: await this.setFilterList("LocationDescription", [""]),
      });
      */
      this.setState({
        ServiceLineList: await this.setFilterList("ServiceLine", [""]),
      });

      this.setState({
        RankList: await this.setFilterList("Rank", [""]),
      });

      this.setState({
        CloudRedboxList: await this.setFilterList("CloudRedbox", [""]),
      });

      this.setState({
        CitrixDeviceModelList: await this.setFilterList("CitrixDeviceModel", [
          "",
        ]),
      });

      this.setState({
        CitrixDeviceModeList: await this.setFilterList("CitrixDeviceMode", [
          "",
        ]),
      });

      this.setState({
        CitrixOSTypeList: await this.setFilterList("CitrixOSType", [""]),
      });

      this.setState({
        CitrixOSVersionList: await this.setFilterList("CitrixOSVersion", [""]),
      });

      this.setState({
        CitrixAppsList: await this.setFilterList("CitrixApps", [""]),
      });

      this.setState({
        IntuneDeviceModelList: await this.setFilterList("IntuneDeviceModel", [
          "",
        ]),
      });

      this.setState({
        IntuneOSTypeList: await this.setFilterList("IntuneOSType", [""]),
      });

      this.setState({
        IntuneDeviceTypeList: await this.setFilterList("IntuneDeviceType", [
          "",
        ]),
      });

      this.setState({
        IntuneAppsList: await this.setFilterList("IntuneApps", [""]),
      });

      this.setState({ loading: false });
    });
  }

  async filterCampaings() {
    let items = [];
    await acquireToken().then(async (token) => {
      let url = `${process.env.REACT_APP_API_URL}/CampaingAPI/GetCampaings/true`;
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      items = res.data.items.campaingName;
    });
    return items;
  }

  async setFilterList(field, fieldParam) {
    let items = [];
    let filter = {
      filterName: field,
      values: fieldParam,
    };
    await acquireToken().then(async (token) => {
      const url = `${process.env.REACT_APP_API_URL}/CampaingAPI/GetCampaingFilterValues`;
      await axios
        .post(url, filter, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          if (res.data.code === 0) {
            items = res.data.items;
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the filter values",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the filter values",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });
    });
    return items;
  }

  async sendEmails(id) {
    const url = `${process.env.REACT_APP_API_URL}/CampaingAPI/SendCampaignEmails`;
    acquireToken().then((token) => {
      const data = {
        CampaignId: Number(id),
        OutEmail: this.state.EmailAccount.emailAccountEmail,
        Subject: this.state.EmailsSubject,
        SenderName: this.state.EmailAccount.emailAccountName,
      };
      axios.post(url, data, { headers: { Authorization: `Bearer ${token}` } });
    });
  }

  handleChange = (name) => ({ target: { value } }) => {
    this.setState({
      ...this.state,
      [name]: value,
    });
    this.updateFilters(name, value);
  };

  handlechangeDrop = (name) => ({ target: { value } }) => {
    this.setState({
      ...this.state,
      [name]: value,
    });
  };

  handleSubmit() {}

  async exportResults() {
    this.setState({ exportResultsText: "Loading", buttonDisabled: true });
    let filtersInformation = {
      filtersInformation: [
        {
          filterName: "Campaing",
          checked: this.state.CampaignsInCheck,
          values:
            this.state.CampaignsIn.length === 0
              ? null
              : this.GetCampaignsInIds(),
        },
        {
          filterName: "Area",
          checked: this.state.AreaCheck,
          values: this.state.Area.length === 0 ? null : this.state.Area,
        },
        {
          filterName: "SubArea",
          checked: this.state.SubAreaCheck,
          values: this.state.SubArea.length === 0 ? null : this.state.SubArea,
        },
        {
          filterName: "Country",
          checked: this.state.CountryCheck,
          values: this.state.Country.length === 0 ? null : this.state.Country,
        },
        {
          filterName: "City",
          checked: this.state.CityCheck,
          values: this.state.City.length === 0 ? null : this.state.City,
        },
        {
          filterName: "Location",
          checked: this.state.LocationCheck,
          values: this.state.Location.length === 0 ? null: this.state.Location,
        },
        {
          filterName: "ServiceLine",
          checked: this.state.ServiceLineCheck,
          values:
            this.state.ServiceLine.length === 0 ? null : this.state.ServiceLine,
        },
        {
          filterName: "SubManagementUnit",
          checked: this.state.SubManagementUnitCheck,
          values:
            this.state.SubManagementUnit.length === 0
              ? null
              : this.state.SubManagementUnit,
        },
        {
          filterName: "SubServiceLine",
          checked: this.state.SubServiceLineCheck,
          values:
            this.state.SubServiceLine.length === 0
              ? null
              : this.state.SubServiceLine,
        },
        {
          filterName: "Rank",
          checked: this.state.RankCheck,
          values: this.state.Rank.length === 0 ? null : this.state.Rank,
        },
        {
          filterName: "CloudRedbox",
          checked: this.state.CloudRedboxCheck,
          values:
            this.state.CloudRedbox.length === 0 ? null : this.state.CloudRedbox,
        },
        {
          filterName: "CitrixDeviceModel",
          checked: this.state.CitrixDeviceModelCheck,
          values:
            this.state.CitrixDeviceModel.length === 0
              ? null
              : this.state.CitrixDeviceModel,
        },
        {
          filterName: "CitrixDeviceMode",
          checked: this.state.CitrixDeviceModeCheck,
          values:
            this.state.CitrixDeviceMode.length === 0
              ? null
              : this.state.CitrixDeviceMode,
        },
        {
          filterName: "CitrixOSType",
          checked: this.state.CitrixOSTypeCheck,
          values:
            this.state.CitrixOSType.length === 0
              ? null
              : this.state.CitrixOSType,
        },
        {
          filterName: "CitrixOSVersion",
          checked: this.state.CitrixOSVersionCheck,
          values:
            this.state.CitrixOSVersion.length === 0
              ? null
              : this.state.CitrixOSVersion,
        },
        {
          filterName: "IntuneDeviceModel",
          checked: this.state.IntuneDeviceModelCheck,
          values:
            this.state.IntuneDeviceModel.length === 0
              ? null
              : this.state.IntuneDeviceModel,
        },
        {
          filterName: "IntuneOSType",
          checked: this.state.IntuneOSTypeCheck,
          values:
            this.state.IntuneOSType.length === 0
              ? null
              : this.state.IntuneOSType,
        },
        {
          filterName: "IntuneDeviceType",
          checked: this.state.IntuneDeviceTypeCheck,
          values:
            this.state.IntuneDeviceType.length === 0
              ? null
              : this.state.IntuneDeviceType,
        },
        {
          filterName: "IntuneOSVersion",
          checked: this.state.IntuneOSVersionCheck,
          values:
            this.state.IntuneOSVersion.length === 0
              ? null
              : this.state.IntuneOSVersion,
        },
      ],
      HireDateStart: this.state.HireDateStart,
      HireDateEnd: this.state.HireDateEnd,
      citrixEnrolled: this.state.citrixEnrolled,
      citrixEnrolledInclude: this.state.citrixEnrolledInclude,
      citrixEnrolledDateStart: this.state.citrixEnrolledDateStart,
      citrixEnrolledDateEnd: this.state.citrixEnrolledDateEnd,
      citrixLastActiviyStart: this.state.citrixLastActiviyStart,
      citrixLastActiviyEnd: this.state.citrixLastActiviyEnd,
      citrixAppsIncluded:
        this.state.citrixAppsIncluded.length === 0
          ? null
          : this.state.citrixAppsIncluded,
      citrixAppsNotIncluded:
        this.state.citrixAppsNotIncluded.length === 0
          ? null
          : this.state.citrixAppsNotIncluded,
      mwEnabled: this.state.mwEnabled,
      mwEnabledInclude: this.state.mwEnabledInclude,
      mwEnrolled: this.state.mwEnrolled,
      mwEnrolledInclude: this.state.mwEnrolledInclude,
      intuneEnrollmentDateStart: this.state.intuneEnrollmentDateStart,
      intuneEnrollmentDateEnd: this.state.intuneEnrollmentDateEnd,
      intuneLastCheckInDateStart: this.state.intuneLastCheckInDateStart,
      intuneLastCheckInDateEnd: this.state.intuneLastCheckInDateEnd,
      intuneAppsIncluded:
        this.state.intuneAppsIncluded.length === 0
          ? null
          : this.state.intuneAppsIncluded,
      intuneAppsNotIncluded:
        this.state.intuneExcludeApps.length === 0
          ? null
          : this.state.intuneExcludeApps,
    };
    const url = `${process.env.REACT_APP_API_URL}/CampaingAPI/DownloadCampaingResultsExcelReport`;
    acquireToken().then((token) => {
      axios
        .post(url, filtersInformation, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/excel" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "exported results.xlsx");
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link);
        })
        .catch((err) => {
          MySwal.fire({
            icon: "error",
            title: "An error has occurred while downloading the file",
            //text: err,
            confirmButtonColor: "#FFE600",
            confirmButtonText: "<div style='color: black'>OK</div>",
          });
        })
        .finally(() => {
          this.setState({
            exportResultsText: "Export Results",
            buttonDisabled: false,
          });
        });
    });
  }

  getBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {};
  }

  onChangeFile(e) {
    if (
      e.target.files[0].size > parseInt(process.env.REACT_APP_MAX_FILE_SIZE)
    ) {
      MySwal.fire({
        icon: "error",
        title: "An error has occurred while uploading the file",
        text: "The file is too big",
        confirmButtonColor: "#FFE600",
        confirmButtonText: "<div style='color: black'>OK</div>",
      });
    } else {
      const filename = e.target.files[0].name;
      //Check if format is valid
      if (filename.substr(filename.lastIndexOf(".") + 1) !== "mht") {
        MySwal.fire({
          title: "Invalid file type",
          text: "The template must be a .mht file",
          icon: "error",
        }).then(() => {
          this.setState({ validtemplateFile: false });
          return;
        });
      } else {
        this.setState({ EmailTemplateError: "" });
        this.setState({ validtemplateFile: true });
        this.setState({ templateFilename: filename });
      }

      let idCardBase64 = "";
      this.getBase64(e.target.files[0], (result) => {
        idCardBase64 = result;

        var str = idCardBase64;
        //var res = str.replace("data:multipart/related;base64,", "");
        var res = str.split(",")[1];

        this.setState({
          campaingTemplatePath: res,
          continueActive: false,
        });
      });
    }
  }

  async createCampaignFilter() {
    if (this.state.peopleMeet <= 0) {
      await MySwal.fire({
        title: "Error creating campaign",
        text: "There must be at least one user who meets the criteria",
        icon: "error",
      });
    } else {
      this.setState({ createCampaignText: "Loading", buttonDisabled: true });
      let newCamp = {
        campaing: {
          campaingId: 0,
          emailAccountId: this.state.EmailAccount.emailAccountId,
          campaingName: this.state.campaignName.trim(),
          campaingDescription: this.state.campaignDescription.trim(),
          campaingStatus: true,
          campaingFilters: {
            filtersInformation: [
              {
                filterName: "Campaing",
                checked: this.state.CampaignsInCheck,
                values:
                  this.state.CampaignsIn.length === 0
                    ? null
                    : this.GetCampaignsInIds(),
              },
              {
                filterName: "Area",
                checked: this.state.AreaCheck,
                values: this.state.Area.length === 0 ? null : this.state.Area,
              },
              {
                filterName: "SubArea",
                checked: this.state.SubAreaCheck,
                values:
                  this.state.SubArea.length === 0 ? null : this.state.SubArea,
              },
              {
                filterName: "Country",
                checked: this.state.CountryCheck,
                values:
                  this.state.Country.length === 0 ? null : this.state.Country,
              },
              {
                filterName: "City",
                checked: this.state.CityCheck,
                values: this.state.City.length === 0 ? null : this.state.City,
              },
              {
                filterName: "Location",
                checked: this.state.LocationCheck,
                values: this.state.Location.length === 0 ? null : this.state.Location,
              },
              {
                filterName: "ServiceLine",
                checked: this.state.ServiceLineCheck,
                values:
                  this.state.ServiceLine.length === 0
                    ? null
                    : this.state.ServiceLine,
              },
              {
                filterName: "SubManagementUnit",
                checked: this.state.SubManagementUnitCheck,
                values:
                  this.state.SubManagementUnit.length === 0
                    ? null
                    : this.state.SubManagementUnit,
              },
              {
                filterName: "SubServiceLine",
                checked: this.state.SubServiceLineCheck,
                values:
                  this.state.SubServiceLine.length === 0
                    ? null
                    : this.state.SubServiceLine,
              },
              {
                filterName: "Rank",
                checked: this.state.RankCheck,
                values: this.state.Rank.length === 0 ? null : this.state.Rank,
              },
              {
                filterName: "CloudRedbox",
                checked: this.state.CloudRedboxCheck,
                values:
                  this.state.CloudRedbox.length === 0
                    ? null
                    : this.state.CloudRedbox,
              },
              {
                filterName: "CitrixDeviceModel",
                checked: this.state.CitrixDeviceModelCheck,
                values:
                  this.state.CitrixDeviceModel.length === 0
                    ? null
                    : this.state.CitrixDeviceModel,
              },
              {
                filterName: "CitrixDeviceMode",
                checked: this.state.CitrixDeviceModeCheck,
                values:
                  this.state.CitrixDeviceMode.length === 0
                    ? null
                    : this.state.CitrixDeviceMode,
              },
              {
                filterName: "CitrixOSType",
                checked: this.state.CitrixOSTypeCheck,
                values:
                  this.state.CitrixOSType.length === 0
                    ? null
                    : this.state.CitrixOSType,
              },
              {
                filterName: "CitrixOSVersion",
                checked: this.state.CitrixOSVersionCheck,
                values:
                  this.state.CitrixOSVersion.length === 0
                    ? null
                    : this.state.CitrixOSVersion,
              },
              {
                filterName: "IntuneDeviceModel",
                checked: this.state.IntuneDeviceModelCheck,
                values:
                  this.state.IntuneDeviceModel.length === 0
                    ? null
                    : this.state.IntuneDeviceModel,
              },
              {
                filterName: "IntuneOSType",
                checked: this.state.IntuneOSTypeCheck,
                values:
                  this.state.IntuneOSType.length === 0
                    ? null
                    : this.state.IntuneOSType,
              },
              {
                filterName: "IntuneDeviceType",
                checked: this.state.IntuneDeviceTypeCheck,
                values:
                  this.state.IntuneDeviceType.length === 0
                    ? null
                    : this.state.IntuneDeviceType,
              },
              {
                filterName: "IntuneOSVersion",
                checked: this.state.IntuneOSVersionCheck,
                values:
                  this.state.IntuneOSVersion.length === 0
                    ? null
                    : this.state.IntuneOSVersion,
              },
            ],
            HireDateStart: this.state.HireDateStart,
            HireDateEnd: this.state.HireDateEnd,
            citrixEnrolled: this.state.citrixEnrolled,
            citrixEnrolledInclude: this.state.citrixEnrolledInclude,
            citrixEnrolledDateStart: this.state.citrixEnrolledDateStart,
            citrixEnrolledDateEnd: this.state.citrixEnrolledDateEnd,
            citrixLastActiviyStart: this.state.citrixLastActiviyStart,
            citrixLastActiviyEnd: this.state.citrixLastActiviyEnd,
            citrixAppsIncluded:
              this.state.citrixAppsIncluded.length === 0
                ? null
                : this.state.citrixAppsIncluded,
            citrixAppsNotIncluded:
              this.state.citrixAppsNotIncluded.length === 0
                ? null
                : this.state.citrixAppsNotIncluded,
            mwEnabled: this.state.mwEnabled,
            mwEnabledInclude: this.state.mwEnabledInclude,
            mwEnrolled: this.state.mwEnrolled,
            mwEnrolledInclude: this.state.mwEnrolledInclude,
            intuneEnrollmentDateStart: this.state.intuneEnrollmentDateStart,
            intuneEnrollmentDateEnd: this.state.intuneEnrollmentDateEnd,
            intuneLastCheckInDateStart: this.state.intuneLastCheckInDateStart,
            intuneLastCheckInDateEnd: this.state.intuneLastCheckInDateEnd,
            intuneAppsIncluded:
              this.state.intuneAppsIncluded.length === 0
                ? null
                : this.state.intuneAppsIncluded,
            intuneAppsNotIncluded:
              this.state.intuneExcludeApps.length === 0
                ? null
                : this.state.intuneExcludeApps,
          },
          campaingTemplatePath: this.state.campaingTemplatePath,
          campaingPeopleNowCount: 0,
          campaingCreateDate: new Date(),
          campaingLastUpdateDate: new Date(),
          campaingUserModifiedId: this.context.userId,
        },
        user: this.context,
        TemplateName: this.state.templateFilename,
      };
      await acquireToken().then(async (token) => {
        const url = `${process.env.REACT_APP_API_URL}/CampaingAPI/CreateCampaingFromQuery`;
        await axios
          .post(url, newCamp, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            if (res.data.code === 0) {
              //TODO: add ability to save the CampaingId and run the email sending later (maybe add a new state to CampaingReceiverEmailSendStatus?)
              this.sendEmails(res.data.description).then(() => {
                MySwal.fire({
                  icon: "success",
                  title: "The campaign was created successfully",
                  text: "The emails are currently being sent",
                  confirmButtonColor: "#FFE600",
                  confirmButtonText: "<div style='color: black'>OK</div>",
                }).then(() => {
                  window.location.href = "/";
                });
              });
            } else if (res.data.code === 2601 || 2627) {
              MySwal.fire({
                icon: "error",
                title: "An error has occurred while adding the email account",
                text:
                  "A campaign with that name already exists, please try a different account name",
                  //res.data.description,
                confirmButtonColor: "#FFE600",
                confirmButtonText: "<div style='color: black'>OK</div>",
              });
            } else {
              MySwal.fire({
                icon: "error",
                title: "An error has occurred while creating the campaign",
                //text: res.data.description,
                confirmButtonColor: "#FFE600",
                confirmButtonText: "<div style='color: black'>OK</div>",
              });
            }
          })
          .catch((error) => {
            if (error.toString().includes("status code 403")) {
              window.location.href = "/NoAuth";
            } else {
              MySwal.fire({
                icon: "error",
                title: "An error has occurred while creating the campaign",
                //text: error,
                confirmButtonColor: "#FFE600",
                confirmButtonText: "<div style='color: black'>OK</div>",
              });
            }
          });
      });
      this.setState({
        createCampaignText: "Create Campaign",
        buttonDisabled: false,
      });
    }
  }

  async createCampaignImported() {
    if (!this.ValidateCreateCampaignFile()) {
      MySwal.close();
      return;
    }

    let newCamp = {
      campaing: {
        campaingId: 0,
        emailAccountId: this.state.EmailAccount.emailAccountId,
        campaingName: this.state.campaignName.trim(),
        campaingDescription: this.state.campaignDescription.trim(),
        campaingStatus: true,
        campaingFilters: {
          filtersInformation: [],
          HireDateStart: null,
          HireDateEnd: null,
          citrixEnrolled: null,
          citrixEnrolledInclude: null,
          citrixEnrolledDateStart: null,
          citrixEnrolledDateEnd: null,
          citrixLastActiviyStart: null,
          citrixLastActiviyEnd: null,
          citrixAppsIncluded: null,
          citrixAppsNotIncluded: null,
          mwEnabled: null,
          mwEnabledInclude: null,
          mwEnrolled: null,
          mwEnrolledInclude: null,
          intuneEnrollmentDateStart: null,
          intuneEnrollmentDateEnd: null,
          intuneLastCheckInDateStart: null,
          intuneLastCheckInDateEnd: null,
          intuneAppsIncluded: null,
          intuneAppsNotIncluded: null,
        },
        campaingTemplatePath: this.state.campaingTemplatePath,
        campaingPeopleNowCount: 0,
        campaingCreateDate: new Date(),
        campaingLastUpdateDate: new Date(),
        campaingUserModifiedId: this.context.userId,
      },
      //campaingImportedPeopleList: this.state.importedFromExcel,
      Emails: this.state.ValidGPNList,
      user: this.context,
      TemplateName: this.state.templateFilename,
    };
    const url = `${process.env.REACT_APP_API_URL}/CampaingAPI/CreateCampaingFromImportedList`;

    await acquireToken().then(async (token) => {
      await axios
        .post(url, newCamp, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          if (res.data.code === 0) {
            //TODO: add ability to save the CampaingId and run the email sending later (maybe add a new state to CampaingReceiverEmailSendStatus?)
            this.sendEmails(res.data.description).then(() => {
              MySwal.fire({
                icon: "success",
                title: "The campaign was created successfully",
                text: "The emails are currently being sent",
                confirmButtonColor: "#FFE600",
                confirmButtonText: "<div style='color: black'>OK</div>",
              }).then(() => {
                window.location.href = "/";
              });
            });
          } else if (res.data.code === 2601 || 2627) {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while adding the email account",
              text:
                "A campaign with that name already exists, please try a different account name",
                //res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while creating the campaign",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while creating the campaign",
              text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
          }
        });
    });
    this.setState({
      createCampaignText: "CREATE CAMPAIGN",
      buttonDisabled: false,
    });
  }

  async executeQuery() {
    this.setState({ executeQueryText: "Loading", buttonDisabled: true });
    let filtersInformation = {
      filtersInformation: [
        {
          filterName: "Campaing",
          checked: this.state.CampaignsInCheck,
          values:
            this.state.CampaignsIn.length === 0
              ? null
              : this.GetCampaignsInIds(),
        },
        {
          filterName: "Area",
          checked: this.state.AreaCheck,
          values: this.state.Area.length === 0 ? null : this.state.Area,
        },
        {
          filterName: "SubArea",
          checked: this.state.SubAreaCheck,
          values: this.state.SubArea.length === 0 ? null : this.state.SubArea,
        },
        {
          filterName: "Country",
          checked: this.state.CountryCheck,
          values: this.state.Country.length === 0 ? null : this.state.Country,
        },
        {
          filterName: "City",
          checked: this.state.CityCheck,
          values: this.state.City.length === 0 ? null : this.state.City,
        },
        {
          filterName: "Location",
          checked: this.state.LocationCheck,
          values: this.state.Location.length === 0 ? null: this.state.Location,
        },
        {
          filterName: "ServiceLine",
          checked: this.state.ServiceLineCheck,
          values:
            this.state.ServiceLine.length === 0 ? null : this.state.ServiceLine,
        },
        {
          filterName: "SubManagementUnit",
          checked: this.state.SubManagementUnitCheck,
          values:
            this.state.SubManagementUnit.length === 0
              ? null
              : this.state.SubManagementUnit,
        },
        {
          filterName: "SubServiceLine",
          checked: this.state.SubServiceLineCheck,
          values:
            this.state.SubServiceLine.length === 0
              ? null
              : this.state.SubServiceLine,
        },
        {
          filterName: "Rank",
          checked: this.state.RankCheck,
          values: this.state.Rank.length === 0 ? null : this.state.Rank,
        },
        {
          filterName: "CloudRedbox",
          checked: this.state.CloudRedboxCheck,
          values:
            this.state.CloudRedbox.length === 0 ? null : this.state.CloudRedbox,
        },
        {
          filterName: "CitrixDeviceModel",
          checked: this.state.CitrixDeviceModelCheck,
          values:
            this.state.CitrixDeviceModel.length === 0
              ? null
              : this.state.CitrixDeviceModel,
        },
        {
          filterName: "CitrixDeviceMode",
          checked: this.state.CitrixDeviceModeCheck,
          values:
            this.state.CitrixDeviceMode.length === 0
              ? null
              : this.state.CitrixDeviceMode,
        },
        {
          filterName: "CitrixOSType",
          checked: this.state.CitrixOSTypeCheck,
          values:
            this.state.CitrixOSType.length === 0
              ? null
              : this.state.CitrixOSType,
        },
        {
          filterName: "CitrixOSVersion",
          checked: this.state.CitrixOSVersionCheck,
          values:
            this.state.CitrixOSVersion.length === 0
              ? null
              : this.state.CitrixOSVersion,
        },
        {
          filterName: "IntuneDeviceModel",
          checked: this.state.IntuneDeviceModelCheck,
          values:
            this.state.IntuneDeviceModel.length === 0
              ? null
              : this.state.IntuneDeviceModel,
        },
        {
          filterName: "IntuneOSType",
          checked: this.state.IntuneOSTypeCheck,
          values:
            this.state.IntuneOSType.length === 0
              ? null
              : this.state.IntuneOSType,
        },
        {
          filterName: "IntuneDeviceType",
          checked: this.state.IntuneDeviceTypeCheck,
          values:
            this.state.IntuneDeviceType.length === 0
              ? null
              : this.state.IntuneDeviceType,
        },
        {
          filterName: "IntuneOSVersion",
          checked: this.state.IntuneOSVersionCheck,
          values:
            this.state.IntuneOSVersion.length === 0
              ? null
              : this.state.IntuneOSVersion,
        },
      ],
      HireDateStart: this.state.HireDateStart,
      HireDateEnd: this.state.HireDateEnd,
      citrixEnrolled: this.state.citrixEnrolled,
      citrixEnrolledInclude: this.state.citrixEnrolledInclude,
      citrixEnrolledDateStart: this.state.citrixEnrolledDateStart,
      citrixEnrolledDateEnd: this.state.citrixEnrolledDateEnd,
      citrixLastActiviyStart: this.state.citrixLastActiviyStart,
      citrixLastActiviyEnd: this.state.citrixLastActiviyEnd,
      citrixAppsIncluded:
        this.state.citrixAppsIncluded.length === 0
          ? null
          : this.state.citrixAppsIncluded,
      citrixAppsNotIncluded:
        this.state.citrixAppsNotIncluded.length === 0
          ? null
          : this.state.citrixAppsNotIncluded,
      mwEnabled: this.state.mwEnabled,
      mwEnabledInclude: this.state.mwEnabledInclude,
      mwEnrolled: this.state.mwEnrolled,
      mwEnrolledInclude: this.state.mwEnrolledInclude,
      intuneEnrollmentDateStart: this.state.intuneEnrollmentDateStart,
      intuneEnrollmentDateEnd: this.state.intuneEnrollmentDateEnd,
      intuneLastCheckInDateStart: this.state.intuneLastCheckInDateStart,
      intuneLastCheckInDateEnd: this.state.intuneLastCheckInDateEnd,
      intuneAppsIncluded:
        this.state.intuneAppsIncluded.length === 0
          ? null
          : this.state.intuneAppsIncluded,
      intuneAppsNotIncluded:
        this.state.intuneExcludeApps.length === 0
          ? null
          : this.state.intuneExcludeApps,
    };

    acquireToken().then((token) => {
      const url = `${process.env.REACT_APP_API_URL}/CampaingAPI/GetFilterQueryExecutionResult`;
      axios
        .post(url, filtersInformation, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          if (res.data.code === 0) {
            const items = res.data.items;
            const peopleMeet = items[0].amountPeopleMeetCriteria;
            const peopleExcluded = items[0].amountPeopleDoNotDisturb;

            this.setState({ peopleMeet: peopleMeet });
            this.setState({ peopleExcluded: peopleExcluded });

            this.setState({
              executeQueryText: "EXECUTE QUERY",
              buttonDisabled: false,
            });
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while executing the query",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
            this.setState({
              executeQueryText: "EXECUTE QUERY",
              buttonDisabled: false,
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while executing the query",
              text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
            this.setState({
              executeQueryText: "EXECUTE QUERY",
              buttonDisabled: false,
            });
          }
        });
    });
  }

  handleChangeSwitch = (name) => (event) => {
    this.setState({ ...this.state, [name]: event.target.checked });
  };

  handleChangeTab = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  cancelCampaing() {
    window.location.reload();
  }

  a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  handleToggle = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  handleToggleImportExcel = () => {
    if (!this.state.openImportExcel) {
      if (!this.ValidateNewCampaignForm()) {
        return;
      }
    }
    this.setState({
      openImportExcel: !this.state.openImportExcel,
    });
  };

  async onChangeImportExcel(e) {
    let file = e.target.files[0];
    if (file.size > process.env.REACT_API_MAX_FILE_SIZE) {
      MySwal.fire({
        icon: "error",
        title: "An error has occurred while uploading the file",
        text: "The file is too big",
        confirmButtonColor: "#FFE600",
        confirmButtonText: "<div style='color: black'>OK</div>",
      });
    } else {
      const filename = file.name;
      //Check if format is valid
      const extension = filename.substr(filename.lastIndexOf(".") + 1);
      if (
        extension !== "xlsx" &&
        extension !== "xls" &&
        extension !== "xlsm" &&
        extension !== "xlm"
      ) {
        await MySwal.fire({
          title: "Invalid file type",
          text: "The file must be a .xlsx, .xlsm, .xls, .xlm file",
          icon: "error",
        }).then(() => {
          this.setState({ ValidUserFile: false });
          return;
        });
      } else {
        this.setState({ ExcelFileError: "" });
        this.setState({ ValidUserFile: true });

        this.setState({
          loadingFile: true,
        });
        e.preventDefault();
        let valid = 0;
        let invalid = 0;
        let notDisturb = 0;
        let excelEmails = [];
        let validGpns = [];
        const data = new FormData();
        data.append("file", file);

        acquireToken().then((token) => {
          axios
            .post(
              `${process.env.REACT_APP_API_URL}/CampaingAPI/ReadExcelEmails`,
              data,
              { headers: { Authorization: `Bearer ${token}` } }
            )
            .then(async (res) => {
              if (res.data.code === 0) {
                excelEmails = res.data.items[0];

                const chunkSize = 1000;
                for (var i = 0; i < excelEmails.length; i += chunkSize) {
                  let temparray = excelEmails.slice(i, i + chunkSize);

                  await acquireToken().then(async (token) => {
                    await axios
                      .post(
                        `${process.env.REACT_APP_API_URL}/CampaingAPI/ValidateEmails`,
                        temparray,
                        { headers: { Authorization: `Bearer ${token}` } }
                      )
                      .then((res) => {
                        if (res.data.code === 0) {
                          let validationResults = res.data.items[0];
                          valid +=
                            validationResults.validGPNList === undefined
                              ? 0
                              : validationResults.validGPNList.length;
                          invalid +=
                            validationResults.invalidEmailsList === undefined
                              ? 0
                              : validationResults.invalidEmailsList.length;
                          notDisturb +=
                            validationResults.doNotDisturbEmailsList ===
                            undefined
                              ? 0
                              : validationResults.doNotDisturbEmailsList.length;

                          validGpns = validGpns.concat(
                            validationResults.validGPNList === undefined
                              ? []
                              : validationResults.validGPNList
                          );
                        } else {
                          throw new Error("Error");
                        }
                      });
                  });
                }
                this.setState({
                  ValidGPNList: validGpns,
                  validPeopleList: valid,
                  invalidEmailsList: invalid,
                  doNotDisturbEmailsList: notDisturb,
                  loadingFile: false,
                });
              } else {
                throw new Error("Error");
              }
            })
            .catch((error) => {
              if (error.toString().includes("status code 403")) {
                window.location.href = "/NoAuth";
              } else {
                MySwal.fire({
                  icon: "error",
                  title: "An error has occurred while uploading the file",
                  //text: error,
                  confirmButtonColor: "#FFE600",
                  confirmButtonText: "<div style='color: black'>OK</div>",
                });
              }
            });
        });
      }
    }
  }

  render() {
    const {
      buttonDisabled,
      exportResultsText,
      createCampaignText,
      executeQueryText,
      loading,
      campaignName,
      campaignDescription,
      EmailAccount,
      emailAddress,
      AreaCheck,
      Area,
      SubAreaCheck,
      SubArea,
      CountryCheck,
      Country,
      CityCheck,
      City,
      //LocationCheck,
      //Location,
      ServiceLineCheck,
      ServiceLine,
      SubManagementUnitCheck,
      SubManagementUnit,
      SubServiceLineCheck,
      SubServiceLine,
      RankCheck,
      Rank,
      //HireDateStart,
      //HireDateEnd,
      CloudRedboxCheck,
      CloudRedbox,
      CampaignsInCheck,
      CampaignsIn,
      CampaignsInList,
      citrixEnrolled,
      CitrixDeviceModelCheck,
      CitrixDeviceModel,
      CitrixDeviceModeCheck,
      CitrixDeviceMode,
      CitrixOSTypeCheck,
      CitrixOSType,
      CitrixOSVersionCheck,
      CitrixOSVersion,
      citrixAppsIncluded,
      citrixAppsNotIncluded,
      mwEnabled,
      mwEnrolled,
      IntuneDeviceModelCheck,
      IntuneDeviceModel,
      IntuneOSTypeCheck,
      IntuneOSType,
      IntuneDeviceTypeCheck,
      IntuneDeviceType,
      IntuneOSVersionCheck,
      IntuneOSVersion,
      intuneAppsIncludedCheck,
      intuneAppsIncluded,
      intuneExcludeApps,
      tabValue,
      AreaList,
      SubAreaList,
      CountryList,
      CityList,
      //LocationList,
      //LocationDescriptionList,
      ServiceLineList,
      SubManagementUnitList,
      SubServiceLineList,
      RankList,
      CloudRedboxList,
      CitrixDeviceModelList,
      CitrixDeviceModeList,
      CitrixOSTypeList,
      CitrixOSVersionList,
      CitrixAppsList,
      IntuneDeviceModelList,
      IntuneOSTypeList,
      IntuneDeviceTypeList,
      IntuneOSVersionList,
      IntuneAppsList,
      peopleMeet,
      peopleExcluded,
      continueForm,
      accountList,

      openImportExcel,
      validPeopleList,
      invalidEmailsList,
      doNotDisturbEmailsList,
      loadingFile,

      EmailsSubject,
    } = this.state;

    return continueForm ? (
      <div>
        <form
          onSubmit={() => {
            this.handleSubmit();
          }}
        >
          <Container>
            <Grid container spacing={3} style={{ marginTop: "1rem" }}>
              <Grid item xs={12}>
                <h3>Create Campaign</h3>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Campaign Name"
                  required
                  multiline
                  value={campaignName}
                  onChange={this.handleChange("campaignName")}
                  style={{ width: "65%" }}
                />
                <div style={{ color: "red" }}>
                  {this.state.CampaignNameError}
                </div>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Campaign Description"
                  required
                  multiline
                  value={campaignDescription}
                  onChange={this.handleChange("campaignDescription")}
                  style={{ width: "65%" }}
                />
                <div style={{ color: "red" }}>
                  {this.state.CampaignDescriptionError}
                </div>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Email Subject"
                  required
                  multiline
                  value={EmailsSubject}
                  onChange={this.handleChange("EmailsSubject")}
                  style={{ width: "65%" }}
                />
                <div style={{ color: "red" }}>
                  {this.state.EmailsSubjectError}
                </div>
              </Grid>

              <Grid item xs={12}>
                <InputLabel
                  id="AccountLabelId"
                  required
                  style={{
                    width: "100%",
                    fontSize: "small",
                    marginBottom: "1rem",
                  }}
                >
                  Email Account
                </InputLabel>

                <Select
                  labelId="AccountLabelId"
                  value={EmailAccount}
                  disabled={this.state.accountList.length === 0}
                  onChange={this.handlechangeDrop("EmailAccount")}
                  style={{ width: "50%" }}
                >
                  {accountList.map((account) => (
                    <MenuItem key={account.emailAccountId} value={account}>
                      {account.emailAccountName}
                    </MenuItem>
                  ))}
                </Select>
                <div style={{ color: "red" }}>
                  {this.state.EmailAccountError}
                </div>
              </Grid>

              <Grid item xs={12}>
                <InputLabel
                  required
                  style={{
                    width: "100%",
                    fontSize: "small",
                    marginBottom: "1rem",
                  }}
                >
                  Email template
                </InputLabel>
                <div onSubmit={this.onFormSubmit}>
                  <input
                    type="file"
                    name="file"
                    onChange={(e) => this.onChangeFile(e)}
                  />
                </div>
                <div style={{ color: "red" }}>
                  {this.state.EmailTemplateError}
                </div>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <ExpansionPanel style={{ width: "50%", margin: "auto" }}>
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <h5>Send preview email</h5>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Grid container spacing={3} style={{ marginTop: "1rem" }}>
                      <Grid item xs={12}>
                        <TextField
                          label="Email Address"
                          value={emailAddress}
                          onChange={this.handleChange("emailAddress")}
                          style={{ width: "50%" }}
                        ></TextField>
                        <div style={{ color: "red" }}>
                          {this.state.TestEmailAddressError}
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          size="medium"
                          block="true"
                          onClick={() => this.SendTestEmail()}
                          style={{ width: "30%" }}
                        >
                          Send to email address
                        </Button>
                      </Grid>
                    </Grid>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </Grid>

              <Grid item xs={6}>
                <Button
                  onClick={this.handleToggleImportExcel}
                  color="primary"
                  variant="contained"
                  size="medium"
                  fontSize="small"
                  style={{ width: "70%" }}
                >
                  Get emails from an excel file
                </Button>
                <Dialog
                  open={openImportExcel}
                  onClose={this.handleToggleImportExcel}
                  style={{ zIndex: 100 }}
                >
                  <DialogTitle id="form-dialog-title">
                    Add an excel file
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      The file must contain a column of emails
                    </DialogContentText>
                    <form
                      onSubmit={() => {
                        this.createCampaignImported();
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid item>
                          <div onSubmit={this.onFormSubmit}>
                            <h3>Upload a file</h3>
                            <input
                              type="file"
                              name="file"
                              onChange={(e) => this.onChangeImportExcel(e)}
                            />
                            <div style={{ color: "red" }}>
                              {this.state.ExcelFileError}
                            </div>
                          </div>
                        </Grid>
                        <Grid item>
                          {loadingFile ? (
                            <div>
                              <Alert color="primary" fade={false}>
                                This operation might take a moment.
                              </Alert>
                              <Spinner />
                            </div>
                          ) : (
                            <div>
                              <label>
                                Total emails:{" "}
                                {validPeopleList +
                                  invalidEmailsList +
                                  doNotDisturbEmailsList}
                              </label>
                              <br />
                              <label>Valid Emails: {validPeopleList}</label>
                              <br />
                              <label>Invalid Emails: {invalidEmailsList}</label>
                              <br />
                              <label>
                                People in Do Not Disturb List:{" "}
                                {doNotDisturbEmailsList}
                              </label>
                            </div>
                          )}
                        </Grid>
                      </Grid>
                      <Button
                        color="primary"
                        onClick={() => {
                          MySwal.fire({
                            title:
                              "Are you sure you want to create the campaign?",
                            text: "The emails will be sent if you continue",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#FFE600",
                            fontSize: "1.5rem",
                            cancelButtonColor: "#2E2E38",
                            confirmButtonText:
                              "<div style='color: black'>Continue</div>",
                            showLoaderOnConfirm: true,
                          }).then((result) => {
                            if (result.value) {
                              MySwal.fire({
                                title: "Creating campaign",
                                allowOutsideClick: false,
                                onBeforeOpen: () => {
                                  Swal.showLoading();
                                },
                              });
                              this.createCampaignImported();
                            }
                          });
                        }}
                      >
                        Create Campaign
                      </Button>
                    </form>
                  </DialogContent>
                  <DialogActions></DialogActions>
                </Dialog>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={this.handleChangeContinue("continueForm")}
                  color="primary"
                  variant="contained"
                  fontSize="small"
                  size="medium"
                  block="true"
                  style={{ width: "70%" }}
                >
                  Get emails from a query
                </Button>
              </Grid>
            </Grid>
          </Container>
        </form>
      </div>
    ) : loading ? (
      <div>
        <Alert color="primary" fade={false}>
          This operation might take a moment.
        </Alert>
        <Spinner />
      </div>
    ) : (
      <Fragment>
        <Grid
          container
          direction="row"
          justify="space-around"
          alignItems="stretch"
          wrap="nowrap"
          spacing={2}
          bgcolor="#EFEFEF"
          style={{
            backgroundColor: "#A5A5B5",
            padding: "1%",
            margin: "0",
            width: "100%",
          }}
        >
          <Grid item xs={12} md={3} sm={6}>
            <Button
              variant="contained"
              size="medium"
              onClick={this.handleChangeContinue("continueForm")}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12} md={3} sm={6}>
            <Button
              variant="contained"
              size="medium"
              onClick={() => {
                this.exportResults();
              }}
              disabled={buttonDisabled}
            >
              {exportResultsText}
            </Button>
          </Grid>
          <Grid item xs={12} md={3} sm={6}>
            <Button
              variant="contained"
              size="medium"
              onClick={() => {
                this.cancelCampaing();
              }}
            >
              Cancel Campaign
            </Button>
          </Grid>
        </Grid>
        <div style={{ width: "90%", margin: "auto" }}>
          <AppBar position="static" style={{ zIndex: 1 }}>
            <Tabs
              value={tabValue}
              onChange={this.handleChangeTab}
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#ffe600",
                },
              }}
            >
              <Tab label="General" {...this.a11yProps(0)} />
              <Tab label="Citrix" {...this.a11yProps(1)} />
              <Tab label="Intune" {...this.a11yProps(2)} />
            </Tabs>
          </AppBar>

          <TabPanel value={tabValue} index={0} style={{ margin: "-24px" }}>
            <Paper style={{ backgroundColor: "rgb(242, 242, 242)" }}>
              <Grid
                container
                spacing={3}
                style={{ paddingTop: "1rem", width: "99%", margin: "auto" }}
              >
                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={AreaCheck}
                        onChange={this.handleChangeSwitch("AreaCheck")}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Area">
                          Area
                        </InputLabel>
                        <CampaignsFilterSelect
                          filterName="Area"
                          label={"Area"}
                          value={Area}
                          id={"Area"}
                          values={AreaList}
                          onChange={this.handleChange.bind(this, "Area")}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={SubAreaCheck}
                        onChange={this.handleChangeSwitch("SubAreaCheck")}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="SubArea">
                          Sub Area
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"SubArea"}
                          label={"SubArea"}
                          value={SubArea}
                          id={"SubArea"}
                          values={SubAreaList}
                          onChange={this.handleChange.bind(this, "SubArea")}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={CloudRedboxCheck}
                        onChange={this.handleChangeSwitch("CloudRedboxCheck")}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Cloud/Redbox">
                          Cloud/Redbox
                        </InputLabel>
                        <CampaignsFilterSelect
                          filterName={"CloudRedbox"}
                          label={"CloudRedbox"}
                          value={CloudRedbox}
                          values={CloudRedboxList}
                          id={"CloudRedbox"}
                          onChange={this.handleChange.bind(this, "CloudRedbox")}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={CountryCheck}
                        onChange={this.handleChangeSwitch("CountryCheck")}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Country">
                          Country
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"Country"}
                          label={"Country"}
                          value={Country}
                          id={"Country"}
                          values={CountryList}
                          onChange={this.handleChange.bind(this, "Country")}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={CityCheck}
                        onChange={this.handleChangeSwitch("CityCheck")}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="City">
                          City
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"City"}
                          label={"City"}
                          value={City}
                          id={"City"}
                          values={CityList}
                          onChange={this.handleChange.bind(this, "City")}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                {/*
                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={LocationCheck}
                        onChange={this.handleChangeSwitch("LocationCheck")}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Location">
                          Location
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"Location"}
                          label={"Location"}
                          value={Location}
                          id={"Location"}
                          values={LocationList}
                          secondaryValues={LocationDescriptionList}
                          onChange={this.handleChange.bind(this, "Location")}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                */}
                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={ServiceLineCheck}
                        onChange={this.handleChangeSwitch("ServiceLineCheck")}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Service Line">
                          Service Line
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"ServiceLine"}
                          label={"ServiceLine"}
                          value={ServiceLine}
                          values={ServiceLineList}
                          id={"ServiceLine"}
                          onChange={this.handleChange.bind(this, "ServiceLine")}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={SubServiceLineCheck}
                        onChange={this.handleChangeSwitch(
                          "SubServiceLineCheck"
                        )}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Sub Service Line">
                          Sub Service Line
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"SubServiceLine"}
                          label={"SubServiceLine"}
                          value={SubServiceLine}
                          id={"SubServiceLine"}
                          values={SubServiceLineList}
                          onChange={this.handleChange.bind(
                            this,
                            "SubServiceLine"
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={SubManagementUnitCheck}
                        onChange={this.handleChangeSwitch(
                          "SubManagementUnitCheck"
                        )}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Sub Management Unit">
                          Sub Management Unit
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"SubManagementUnit"}
                          label={"SubManagementUnit"}
                          value={SubManagementUnit}
                          values={SubManagementUnitList}
                          id={"SubManagementUnit"}
                          onChange={this.handleChange.bind(
                            this,
                            "SubManagementUnit"
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={RankCheck}
                        onChange={this.handleChangeSwitch("RankCheck")}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Rank">
                          Rank
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"Rank"}
                          label={"Rank"}
                          value={Rank}
                          values={RankList}
                          id={"Rank"}
                          onChange={this.handleChange.bind(this, "Rank")}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label>Hire Date Start</label>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        className={useStyles.formControl}
                        style={{ width: "100%", marginTop: "1rem" }}
                      >
                        <DatePicker
                          value={this.state.HireDateStart}
                          selected={this.state.HireDateStart}
                          style={{
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            width: "100%",
                          }}
                          onChange={(date) => {
                            this.setState({
                              HireDateStart: date,
                            });
                          }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label>Hire Date End</label>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        className={useStyles.formControl}
                        style={{ width: "100%", marginTop: "1rem" }}
                      >
                        <DatePicker
                          value={this.state.HireDateEnd}
                          selected={this.state.HireDateEnd}
                          style={{
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            width: "100%",
                          }}
                          onChange={(date) => {
                            this.setState({
                              HireDateEnd: date,
                            });
                          }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={CampaignsInCheck}
                        onChange={this.handleChangeSwitch("CampaignsInCheck")}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        className={useStyles.formControl}
                        style={{ width: "100%" }}
                      >
                        <InputLabel shrink htmlFor="Campaigns">
                          Campaigns
                        </InputLabel>
                        <CampaignsFilterSelect
                          filterName={"CampaignsIn"}
                          label={"CampaignsIn"}
                          value={CampaignsIn}
                          values={CampaignsInList}
                          id={"CampaignsIn"}
                          onChange={this.handleChange.bind(this, "CampaignsIn")}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </TabPanel>

          <TabPanel value={tabValue} index={1} style={{ margin: "-24px" }}>
            <Paper style={{ backgroundColor: "rgb(242, 242, 242)" }}>
              <Grid
                container
                spacing={3}
                style={{ paddingTop: "1rem", width: "99%", margin: "auto" }}
              >
                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label>Citrix Enrolled</label>
                    </Grid>
                    <Grid item xs={12}>
                      <InputLabel shrink htmlFor="Citrix Enrolled">
                        Citrix Enrolled
                      </InputLabel>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <Select
                          labelId="citrixEnrolled"
                          id="citrixEnrolled"
                          value={citrixEnrolled}
                          onChange={this.handleChange("citrixEnrolled")}
                        >
                          <MenuItem
                            value={null}
                            style={{ height: "2rem" }}
                          ></MenuItem>
                          <MenuItem value={true}>Yes</MenuItem>
                          <MenuItem value={false}>No</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={CitrixDeviceModelCheck}
                        onChange={this.handleChangeSwitch(
                          "CitrixDeviceModelCheck"
                        )}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Citrix Device Model">
                          Citrix Device Model
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"CitrixDeviceModel"}
                          label={"CitrixDeviceModel"}
                          value={CitrixDeviceModel}
                          values={CitrixDeviceModelList}
                          id={"CitrixDeviceModel"}
                          onChange={this.handleChange.bind(
                            this,
                            "CitrixDeviceModel"
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={CitrixDeviceModeCheck}
                        onChange={this.handleChangeSwitch(
                          "CitrixDeviceModeCheck"
                        )}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Citrix Device Mode">
                          Citrix Device Mode
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"CitrixDeviceMode"}
                          label={"CitrixDeviceMode"}
                          value={CitrixDeviceMode}
                          values={CitrixDeviceModeList}
                          id={"CitrixDeviceMode"}
                          onChange={this.handleChange.bind(
                            this,
                            "CitrixDeviceMode"
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={CitrixOSTypeCheck}
                        onChange={this.handleChangeSwitch("CitrixOSTypeCheck")}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Citrix OS Type">
                          Citrix OS Type
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"CitrixOSType"}
                          label={"CitrixOSType"}
                          value={CitrixOSType}
                          values={CitrixOSTypeList}
                          id={"CitrixOSType"}
                          onChange={this.handleChange.bind(
                            this,
                            "CitrixOSType"
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={CitrixOSVersionCheck}
                        onChange={this.handleChangeSwitch(
                          "CitrixOSVersionCheck"
                        )}
                        margin="normal"
                      />
                      Include
                    </Grid>

                    <Grid item cs={12} style={{ width: "100%" }}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Citrix OS Version">
                          Citrix OS Version
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"CitrixOSVersion"}
                          label={"CitrixOSVersion"}
                          value={CitrixOSVersion}
                          id={"CitrixOSVersion"}
                          values={CitrixOSVersionList}
                          onChange={this.handleChange.bind(
                            this,
                            "CitrixOSVersion"
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch size="small" checked={true} margin="normal" />
                      Include
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Citrix Include Apps">
                          Citrix Include Apps
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"CitrixApps"}
                          label={"citrixAppsIncluded"}
                          value={citrixAppsIncluded}
                          values={CitrixAppsList}
                          id={"citrixAppsIncluded"}
                          onChange={this.handleChange.bind(
                            this,
                            "citrixAppsIncluded"
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch size="small" checked={false} margin="normal" />
                      Include
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        className={useStyles.formControl}
                        style={{ width: "100%" }}
                      >
                        <InputLabel shrink htmlFor="Citrix Exclude Apps">
                          Citrix Exclude Apps
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"citrixAppsNotIncluded"}
                          label={"citrixAppsNotIncluded"}
                          value={citrixAppsNotIncluded}
                          values={CitrixAppsList}
                          id={"citrixAppsNotIncluded"}
                          onChange={this.handleChange.bind(
                            this,
                            "citrixAppsNotIncluded"
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label>Citrix Enrolled Date Start</label>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        className={useStyles.formControl}
                        style={{ width: "100%", marginTop: "1rem" }}
                      >
                        <DatePicker
                          value={this.state.citrixEnrolledDateStart}
                          selected={this.state.citrixEnrolledDateStart}
                          style={{
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            width: "100%",
                          }}
                          onChange={(date) => {
                            this.setState({
                              citrixEnrolledDateStart: date,
                            });
                          }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label>Citrix Enrolled Date End</label>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        style={{ width: "100%", marginTop: "1rem" }}
                      >
                        <DatePicker
                          selected={this.state.citrixEnrolledDateEnd}
                          onChange={(date) => {
                            this.setState({
                              citrixEnrolledDateEnd: date,
                            });
                          }}
                          value={this.state.citrixEnrolledDateEnd}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label>Citrix Last Activity Date Start</label>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        style={{ width: "100%", marginTop: "1rem" }}
                      >
                        <DatePicker
                          selected={this.state.citrixLastActiviyStart}
                          onChange={(date) => {
                            this.setState({
                              citrixLastActiviyStart: date,
                            });
                          }}
                          value={this.state.citrixLastActiviyStart}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label>Citrix Last Activity Date End</label>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        style={{ width: "100%", marginTop: "1rem" }}
                      >
                        <DatePicker
                          selected={this.state.citrixLastActiviyEnd}
                          onChange={(date) => {
                            this.setState({
                              citrixLastActiviyEnd: date,
                            });
                          }}
                          value={this.state.citrixLastActiviyEnd}
                          style={{ width: "100%" }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </TabPanel>

          <TabPanel value={tabValue} index={2} style={{ margin: "-24px" }}>
            <Paper style={{ backgroundColor: "rgb(242, 242, 242)" }}>
              <Grid
                container
                spacing={3}
                style={{ paddingTop: "1rem", width: "99%", margin: "auto" }}
              >
                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label>MW Enabled</label>
                    </Grid>
                    <Grid item xs={12}>
                      <InputLabel shrink htmlFor="MW Enabled">
                        MW Enabled
                      </InputLabel>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <Select
                          labelId="mwEnabled"
                          id="mwEnabled"
                          value={mwEnabled}
                          onChange={this.handleChange("mwEnabled")}
                        >
                          <MenuItem
                            value={null}
                            style={{ height: "2rem" }}
                          ></MenuItem>
                          <MenuItem value={true}>Yes</MenuItem>
                          <MenuItem value={false}>No</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label>MW Enrolled</label>
                    </Grid>
                    <Grid item xs={12}>
                      <InputLabel shrink htmlFor="MW Enrolled">
                        MW Enrolled
                      </InputLabel>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <Select
                          labelId="demo-customized-select-label"
                          id="demo-customized-select"
                          value={mwEnrolled}
                          onChange={this.handleChange("mwEnrolled")}
                        >
                          <MenuItem
                            value={null}
                            style={{ height: "2rem" }}
                          ></MenuItem>
                          <MenuItem value={true}>Yes</MenuItem>
                          <MenuItem value={false}>No</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={IntuneDeviceModelCheck}
                        onChange={this.handleChangeSwitch(
                          "IntuneDeviceModelCheck"
                        )}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Intune Device Model">
                          Intune Device Model
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"IntuneDeviceModel"}
                          label={"IntuneDeviceModel"}
                          value={IntuneDeviceModel}
                          values={IntuneDeviceModelList}
                          id={"IntuneDeviceModel"}
                          onChange={this.handleChange.bind(
                            this,
                            "IntuneDeviceModel"
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={IntuneOSTypeCheck}
                        onChange={this.handleChangeSwitch("IntuneOSTypeCheck")}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Intune OS Type">
                          Intune OS Type
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"IntuneOSType"}
                          label={"IntuneOSType"}
                          value={IntuneOSType}
                          id={"IntuneOSType"}
                          values={IntuneOSTypeList}
                          onChange={this.handleChange.bind(
                            this,
                            "IntuneOSType"
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={IntuneDeviceTypeCheck}
                        onChange={this.handleChangeSwitch(
                          "IntuneDeviceTypeCheck"
                        )}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Intune Device Type">
                          Intune Device Type
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"IntuneDeviceType"}
                          label={"IntuneDeviceType"}
                          value={IntuneDeviceType}
                          id={"IntuneDeviceType"}
                          values={IntuneDeviceTypeList}
                          onChange={this.handleChange.bind(
                            this,
                            "IntuneDeviceType"
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={IntuneOSVersionCheck}
                        onChange={this.handleChangeSwitch(
                          "IntuneOSVersionCheck"
                        )}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel shrink htmlFor="Intune OS Version">
                          Intune OS Version
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"IntuneOSVersion"}
                          label={"IntuneOSVersion"}
                          value={IntuneOSVersion}
                          id={"IntuneOSVersion"}
                          values={IntuneOSVersionList}
                          onChange={this.handleChange.bind(
                            this,
                            "IntuneOSVersion"
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch
                        size="small"
                        checked={intuneAppsIncludedCheck}
                        onChange={true}
                        margin="normal"
                      />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        className={useStyles.formControl}
                        style={{ width: "100%" }}
                      >
                        <InputLabel shrink htmlFor="Intune Apps Installed">
                          Intune Included Apps
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"intuneAppsIncluded"}
                          label={"intuneAppsIncluded"}
                          value={intuneAppsIncluded}
                          id={"intuneAppsIncluded"}
                          values={IntuneAppsList}
                          onChange={this.handleChange.bind(
                            this,
                            "intuneAppsIncluded"
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      Exclude
                      <IOSSwitch size="small" checked={false} margin="normal" />
                      Include
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        className={useStyles.formControl}
                        style={{ width: "100%" }}
                      >
                        <InputLabel shrink htmlFor="Intune Apps Installed">
                          Intune Excluded Apps
                        </InputLabel>

                        <CampaignsFilterSelect
                          filterName={"intuneExcludeApps"}
                          label={"intuneExcludeApps"}
                          value={intuneExcludeApps}
                          id={"intuneExcludeApps"}
                          values={IntuneAppsList}
                          onChange={this.handleChange.bind(
                            this,
                            "intuneExcludeApps"
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label>Intune Enrolled Date Start</label>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        style={{ width: "100%", marginTop: "1rem" }}
                      >
                        <DatePicker
                          selected={this.state.intuneEnrollmentDateStart}
                          onChange={(date) => {
                            this.setState({
                              intuneEnrollmentDateStart: date,
                            });
                          }}
                          value={this.state.intuneEnrollmentDateStart}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label>Intune Enrolled Date End</label>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        style={{ width: "100%", marginTop: "1rem" }}
                      >
                        <DatePicker
                          selected={this.state.intuneEnrollmentDateEnd}
                          onChange={(date) => {
                            this.setState({
                              intuneEnrollmentDateEnd: date,
                            });
                          }}
                          value={this.state.intuneEnrollmentDateEnd}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label>Intune Last Activity Date Start</label>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        style={{ width: "100%", marginTop: "1rem" }}
                      >
                        <DatePicker
                          selected={this.state.intuneLastCheckInDateStart}
                          onChange={(date) => {
                            this.setState({
                              intuneLastCheckInDateStart: date,
                            });
                          }}
                          value={this.state.intuneLastCheckInDateStart}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={4}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <label>intune Last Activity Date End</label>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        style={{ width: "100%", marginTop: "1rem" }}
                      >
                        <DatePicker
                          selected={this.state.intuneLastCheckInDateEnd}
                          onChange={(date) => {
                            this.setState({
                              intuneLastCheckInDateEnd: date,
                            });
                          }}
                          value={this.state.intuneLastCheckInDateEnd}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </TabPanel>

          <Paper
            style={{
              backgroundColor: "rgb(242, 242, 242)",
              marginTop: "1rem",
              marginBottom: "1rem",
            }}
          >
            <Grid
              container
              spacing={3}
              style={{ width: "99%", margin: "auto" }}
            >
              <Grid item xs={3}>
                <Button
                  color="primary"
                  onClick={() => {
                    this.executeQuery();
                  }}
                  disabled={buttonDisabled}
                  style={{ width: "100%", marginTop: "0.5rem" }}
                >
                  {executeQueryText}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <div style={{ fontSize: "20px" }}>
                  {peopleMeet - peopleExcluded} will receive the campaign
                </div>
                <div style={{ fontSize: "15px" }}>
                  {peopleMeet} found - {peopleExcluded} in do not disturb
                </div>
              </Grid>
              <Grid item xs={3}>
                <Button
                  color="primary"
                  onClick={() => {
                    MySwal.fire({
                      title: "Are you sure you want to create the campaign?",
                      text: "The emails will be sent if you continue",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#FFE600",
                      fontSize: "1.5rem",
                      cancelButtonColor: "#2E2E38",
                      confirmButtonText:
                        "<div style='color: black'>Continue</div>",
                    }).then((result) => {
                      if (result.value) {
                        MySwal.fire({
                          title: "Creating campaign",
                          allowOutsideClick: false,
                          onBeforeOpen: () => {
                            Swal.showLoading();
                          },
                        });
                        this.createCampaignFilter();
                      }
                    });
                  }}
                  disabled={buttonDisabled}
                  style={{ width: "100%", marginTop: "0.5rem" }}
                >
                  {createCampaignText}
                </Button>
              </Grid>
            </Grid>
          </Paper>
          <div>
            {buttonDisabled ? (
              <Alert color="primary" fade={false}>
                This operation might take a moment.
              </Alert>
            ) : (
              ""
            )}
          </div>
        </div>
      </Fragment>
    );
  }

  ValidateNewCampaignForm = () => {
    let valid = true;

    // Campaign name validations
    if (
      this.state.campaignName === "" ||
      this.state.campaignName === undefined
    ) {
      this.setState({ CampaignNameError: "This field is required" });
      valid = false;
    } else if (this.state.campaignName.length > 200) {
      this.setState({
        CampaignNameError: "The maximun number of characters allowed is 200",
      });
      valid = false;
    } else if (
      // eslint-disable-next-line
      /^[A-Za-z0-9,\.\-_\(\)!\?\/: ]*$/.test(this.state.campaignName) === false
    ) {
      this.setState({
        CampaignNameError: "The field contains invalid characters",
      });
      valid = false;
    } else {
      this.setState({ CampaignNameError: "" });
    }

    // Campaign description validations
    if (
      this.state.campaignDescription === "" ||
      this.state.campaignDescription === undefined
    ) {
      this.setState({ CampaignDescriptionError: "This field is required" });
      valid = false;
    } else if (this.state.campaignDescription.length > 250) {
      this.setState({
        CampaignDescriptionError:
          "The maximun number of characters allowed is 250",
      });
      valid = false;
    } else if (
      // eslint-disable-next-line
      /^[A-Za-z0-9,\.\-_\(\)!\?\/: ]*$/.test(this.state.campaignDescription) ===
      false
    ) {
      this.setState({
        CampaignDescriptionError: "The field contains invalid characters",
      });
      valid = false;
    } else {
      this.setState({ CampaignDescriptionError: "" });
    }

    // Email subject validations
    if (
      this.state.EmailsSubject === "" ||
      this.state.EmailsSubject === undefined
    ) {
      this.setState({ EmailsSubjectError: "This field is required" });
      valid = false;
    } else if (this.state.EmailsSubject.length > 200) {
      this.setState({
        EmailsSubjectError: "The maximum number of characters allowed is 200",
      });
      valid = false;
    } else {
      this.setState({ EmailsSubjectError: "" });
    }

    // Email Account validations
    if (
      this.state.EmailAccount === "" ||
      this.state.EmailAccount === undefined
    ) {
      this.setState({ EmailAccountError: "This field is required" });
      valid = false;
    } else {
      this.setState({ EmailAccountError: "" });
    }

    // Email template validations
    if (
      this.state.campaingTemplatePath === "" ||
      this.state.campaingTemplatePath === undefined
    ) {
      this.setState({ EmailTemplateError: "This field is required" });
      valid = false;
    } else if (!this.state.validtemplateFile) {
      this.setState({ EmailTemplateError: "The file is not the correct type" });
      valid = false;
    } else {
      this.setState({ EmailTemplateError: "" });
    }
    return valid;
  };

  ValidateTestEmail = () => {
    let valid = true;
    // Test emailaddress validations
    if (
      this.state.emailAddress === "" ||
      this.state.emailAddress === undefined
    ) {
      this.setState({ TestEmailAddressError: "Please enter email address" });
      valid = false;
    } else {
      this.setState({ TestEmailAddressError: "" });
    }

    // Email template validations
    if (
      this.state.campaingTemplatePath === "" ||
      this.state.campaingTemplatePath === undefined
    ) {
      this.setState({ EmailTemplateError: "This field is required" });
      valid = false;
    } else if (!this.state.validtemplateFile) {
      this.setState({ EmailTemplateError: "The file is not the correct type" });
      valid = false;
    } else {
      this.setState({ EmailTemplateError: "" });
    }

    // Email subject validations
    if (
      this.state.EmailsSubject === "" ||
      this.state.EmailsSubject === undefined
    ) {
      this.setState({ EmailsSubjectError: "This field is required" });
      valid = false;
    } else if (this.state.EmailsSubject.length > 200) {
      this.setState({
        EmailsSubjectError: "The maximum number of characters allowed is 200",
      });
      valid = false;
    } else {
      this.setState({ EmailsSubjectError: "" });
    }

    return valid;
  };

  ValidateCreateCampaignFile = () => {
    if (this.state.ValidGPNList.length === 0) {
      this.setState({
        ExcelFileError: "Upload a file with at least one valid user",
      });
      return false;
    }
    return true;
  };

  SendTestEmail = () => {
    if (!this.ValidateTestEmail()) {
      return;
    }

    MySwal.fire({
      title: "Sending preview email",
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });

    let url = `${process.env.REACT_APP_API_URL}/CampaingAPI/SendTestEmail`;
    if (this.state.EmailAccount !== "") {
      url += `?email=${this.state.EmailAccount.emailAccountEmail}`;
    }

    acquireToken().then((token) => {
      axios
        .post(
          url,
          {
            email: this.state.emailAddress,
            template: this.state.campaingTemplatePath,
            subject: this.state.EmailsSubject,
            senderName: this.state.EmailAccount.emailAccountName,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then((res) => {
          if (res.data.code === 0) {
            MySwal.fire({
              icon: "success",
              title: "The email was sent successfully",
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while sending the email",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while sending the email",
              text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
          }
        });
    });
  };

  async setCountryFilterList(source, values) {
    let items = [];
    let filter = {
      areas: this.state.Area,
      subAreas: this.state.SubArea,
    };

    if (source === "SubArea") {
      filter["subAreas"] = values;
    } else if (source === "Area") {
      filter["areas"] = values;
    }

    await acquireToken().then(async (token) => {
      const url = `${process.env.REACT_APP_API_URL}/CampaingAPI/GetCountryFilterValues`;
      await axios
        .post(url, filter, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          if (res.data.code === 0) {
            items = res.data.items;
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the filter values",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the filter values",
              text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });
    });

    return items;
  }

  GetCampaignsInIds() {
    let ids = [];
    this.state.CampaignsIn.forEach((campaign) => {
      ids.push(this.state.campaignsInIds[campaign]);
    });
    return ids;
  }

  encryptStringXORtoHex(input, key) {
    let result = "";
    while (key.length < input.length) {
      key += key;
    }
    for (var i = 0; i < input.length; i++) {
      var value1 = input[i].charCodeAt(0);
      var value2 = key[i].charCodeAt(0);

      var xorValue = value1 ^ value2;

      var xorValueAsHexString = xorValue.toString("16");

      if (xorValueAsHexString.length < 2) {
        xorValueAsHexString = "0" + xorValueAsHexString;
      }

      result += xorValueAsHexString;
    }
    return result;
  }

  validateEmails(emails) {}
}

CampaignsCreateForm.contextType = LoggedUserContext;
